<script>

import {regexPatterns} from "../../../src/components/utils/utils";
import {STATES} from "./../../helpers/constantsHelper";
import {mapActions} from "vuex";

export default {
  name: "requestToJoinDialog",
  data() {
    return {
      loading: false,
      requestToJoinForm: {
        firstName: "",
        lastName: "",
        companyName: "",
        state: "",
        email: "",
        phoneNumber: "",
        message: ""
      },
      rules: {
        firstName: {
          required: true,
          message: "Please enter your first name",
          trigger: "blur"
        },
        lastName: {
          required: true,
          message: "Please enter your last name",
          trigger: "blur"
        },
        companyName: {
          required: true,
          message: "Please enter your company name",
          trigger: "blur"
        },
        state: {
          required: true,
          message: "Please select your state",
          trigger: ["change", "blur"]
        },
        email: {
          required: true,
          message: "Please enter a correct email",
          trigger: "blur",
          pattern: regexPatterns.email
        },
        phoneNumber: {
          required: true,
          message: "Please enter your phone number",
          trigger: "blur",
          pattern: regexPatterns.phoneNumber
        },
        // message: {
        //   required: true,
        //   message: "Please enter your message",
        //   trigger: "blur"
        // }
      }
    }
  },
  props: {
    requestToJoinDialogVisible: Boolean,
  },
  methods: {
    ...mapActions("request", ["sendRequestToJoinUConnectEmail"]),
    STATES() {
      return STATES
    },
    validateField(field) {
      this.$refs.requestToJoinForm.validateField(field);
    },
    formatPhoneNumber(value) {
      return value ? value.toString().replace(/[^\d]/g, '') : '';
    },
    handleClose() {
      this.$emit('update:requestToJoinDialogVisible', false);
      this.requestToJoinForm = {
        firstName: "",
        lastName: "",
        companyName: "",
        state: "",
        email: "",
        phoneNumber: "",
        message: ""
      };
      if (this.$refs.requestToJoinForm) {
        this.$refs.requestToJoinForm.clearValidate();
      }
      this.$emit('onClose');
    },
    onSubmit(formName) {
      if (this.loading) return;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.loading) return;
          this.loading = true;
          let pat= {
            firstName: this.requestToJoinForm.firstName,
            lastName: this.requestToJoinForm.lastName,
            companyName: this.requestToJoinForm.companyName,
            state: this.requestToJoinForm.state,
            email: this.requestToJoinForm.email,
            phoneNumber: this.requestToJoinForm.phoneNumber,
            message: this.requestToJoinForm.message ? this.requestToJoinForm.message : "N/A",
          }
          this.sendRequestToJoinUConnectEmail({pat:pat,callback:this.joinUConnectEmailCallback});
        } else {
          return false;
        }
      });
    },
    joinUConnectEmailCallback(res) {
      this.loading = false;
      if (res.code == 0) {
        this.$notify({
          title: 'Success',
          message: 'UNIFI Property request sent successfully',
          type: 'success',
          customClass: 'my-custom-notify',
          duration: 6000,
        });
        this.handleClose();
      } else {
        this.$box.alert("", res.data.message, "error");
      }
    },
  }
}
</script>

<template>
  <el-dialog
      :show-close="false"
      :visible.sync="requestToJoinDialogVisible"
      :before-close="handleClose"
      center
      custom-class="contact-dialog"
  >
    <template #title>
      <div class="contact-title">
        Request to Join UNIFI Property
        <div class="icon" @click="handleClose">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </template>
    <div>

      <el-form
          ref="requestToJoinForm"
          :model="requestToJoinForm"
          :rules="rules"
          label-position="top"
          label-width="100px"
          @submit.native.prevent
          style="font-family: DINosaur-a, sans-serif;">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="First Name" prop="firstName">
                  <el-input
                      v-model="requestToJoinForm.firstName"
                      maxlength="50"
                      placeholder="Your first name"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Last Name" prop="lastName">
                  <el-input
                      v-model="requestToJoinForm.lastName"
                      maxlength="100"
                      placeholder="Your last name"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Company" prop="companyName">
                  <el-input
                      v-model="requestToJoinForm.companyName"
                      maxlength="100"
                      placeholder="Agency/Developer name"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Location" prop="state">
                  <el-select v-model="requestToJoinForm.state" @change="validateField('state')" clearable filterable placeholder="Select a state" style="width: 100%">
                    <el-option
                        v-for="item in STATES()"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Email" prop="email">
                  <el-input
                      v-model="requestToJoinForm.email"
                      maxlength="100"
                      placeholder="Your email"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Phone Number" prop="phoneNumber">
                  <el-input
                      v-model="requestToJoinForm.phoneNumber"
                      maxlength="20"
                      placeholder="Your phone number"
                      @input="requestToJoinForm.phoneNumber = formatPhoneNumber($event)"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="Message" prop="message">
                  <el-input
                      type="textarea"
                      v-model="requestToJoinForm.message"
                      maxlength="1000"
                      show-word-limit
                      placeholder="Message"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item style="text-align:center">
                  <el-button class="submit-button" @click="onSubmit('requestToJoinForm')"
                  >Confirm
                    <i v-if="loading" class="el-icon-loading"></i>
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>

<style scoped>

.contact-title {
  color: #003333;
  text-align: left;
  font-size: 22px;
  font-family: DINosaur-a, sans-serif;
  font-weight: 600;
}

.contact-title .icon {
  float: right;
  width: 35px;
  height: 35px;
  font-size: 35px;
  cursor: pointer;
  color: #aaaaaa;
  position: relative;
  top: -15px;
  right: -10px;
}
.submit-button {
  width: 200px;
  height: 50px;
  color: #ffffff !important;
  text-align: center;
  border-radius: 5px;
  border: 4px solid #003333 !important;
  background-color: #003333 !important;
  font: 500 20px DINosaur-a, sans-serif;
  margin-top: 15px;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.el-form--label-top /deep/ .el-form-item__label {
  padding: 0 !important;
}
.el-dialog--center /deep/ .el-dialog__body {
  padding: 0 250px 30px 0 !important;
}
.el-select-dropdown__item {
  background-color: #ffffff;
  color: #003333;
}
.el-select-dropdown__item:hover {
  background-color: #003333;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/requestToJoinDialog.vue